import React from "react";
import "./Corporate.css";
import CorporateNotice from "./Notice";

const industries = [
  "Construction",
  "Manufacturing",
  "E-commerce",
  "Agriculture",
  "Fast-Moving Consumer Goods (FMCG)"
];

export default function Corporate() {
  return (
    <div className="corporate">

      {/* HERO */}
      <section className="corporate-hero">
        <h1>Corporate Logistics Solutions</h1>
        <p>
          Reliable, scalable logistics for enterprises and SMEs across Africa.
          Dedicated fleets, contract pricing, and real-time delivery tracking.
        </p>

        <button className="primary-btn"    onClick={() => {
    const element = document.getElementById("corporate-notice");
    const yOffset = -120; // adjust this value
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  }}>Learn more</button>
      </section>

      <CorporateNotice />
      
      {/* ENTERPRISE LOGISTICS */}
      <section className="section">
        <h2>Enterprise Logistics</h2>

        <div className="grid">
          <div className="card">
            <h3>Fleet Outsourcing</h3>
            <p>
              Reduce operational costs by outsourcing transport operations to
              Mr Truck's managed fleet network.
            </p>
          </div>

          <div className="card">
            <h3>Dedicated Routes</h3>
            <p>
              Secure dedicated trucks for predictable routes and consistent
              delivery schedules.
            </p>
          </div>

          <div className="card">
            <h3>Contract Pricing</h3>
            <p>
              Lock in competitive transport rates with long-term logistics
              contracts.
            </p>
          </div>

          <div className="card">
            <h3>Monthly Invoicing</h3>
            <p>
              Simplified accounting with monthly billing and consolidated
              delivery reporting.
            </p>
          </div>
        </div>
      </section>

      {/* SME LOGISTICS */}
      <section className="section gray">
        <h2>SME Logistics</h2>

        <div className="grid">

          <div className="card">
            <h3>Stock Deliveries</h3>
            <p>
              Deliver goods to retail outlets, distributors, and customers
              efficiently.
            </p>
          </div>

          <div className="card">
            <h3>Warehouse Transfers</h3>
            <p>
              Move inventory between warehouses and distribution centers with
              ease.
            </p>
          </div>

          <div className="card">
            <h3>Recurring Dispatch</h3>
            <p>
              Schedule regular deliveries for businesses that ship frequently.
            </p>
          </div>

        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="section">
        <h2>Industries We Serve</h2>

        <div className="industry-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-card">
              {industry}
            </div>
          ))}
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="corporate-cta">
        <h2>Need a reliable logistics partner?</h2>
        <p>
          Let Mr Truck power your supply chain with dependable transport
          solutions.
        </p>

<a
  href="https://play.google.com/store/apps/details?id=com.MrTruck"
  target="_blank"
  rel="noopener noreferrer"
>
  <button className="primary-btn large">Request a Quote</button>
</a>
      </section>

    </div>
  );
}